/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claims_How_To_TitleInputs */

const en_claims_how_to_title = /** @type {(inputs: Claims_How_To_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How to submit a claim`)
};

const fr_claims_how_to_title = /** @type {(inputs: Claims_How_To_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment soumettre une réclamation`)
};

/**
* | output |
* | --- |
* | "How to submit a claim" |
*
* @param {Claims_How_To_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const claims_how_to_title = /** @type {((inputs?: Claims_How_To_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claims_How_To_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claims_how_to_title(inputs)
	return fr_claims_how_to_title(inputs)
});